// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"0629bd5b","318":"bcd1e331","422":"53d49391"}[chunkId] + ".chunk.js";
};